var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112.03 111.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7f7f7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.32,13.11s.05,72.27.05,79.22c0,6.28-.42,13.49-5.37,17.35-3.61,2.81-8.56,2.93-13.13,2.93l-74.5,0c-5.83,0-12.48-.38-16.13-4.92-2.77-3.44-2.9-8.24-2.89-12.66q0-38,0-76c0-4.69.15-9.81,3.17-13.41C153.3,1.18,159.91.81,165.74.8L236,.63c4.62,0,9.38,0,13.66,1.73,4.1,1.66,8.67,3.37,8.63,13.78M220.17,47a31.75,31.75,0,0,0-4.59-2.91A15.94,15.94,0,0,0,195,52.62a27.05,27.05,0,0,0-.2,20,15.43,15.43,0,0,0,25.22,5.72c.06-.06.24,0,.39,0L221,81.6h12.63V29.09H220.17Zm-46,34.63h13.29V44.11H174.14Zm-1-48.87a7.57,7.57,0,1,0,15.13.27,7.59,7.59,0,0,0-15.13-.27",
    transform: "translate(-146.35 -0.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.17,63.05c0,4-2.76,7.11-6.33,7.1s-6.52-3.37-6.43-7.37,2.77-7,6.47-7c3.89,0,6.3,2.79,6.29,7.21",
    transform: "translate(-146.35 -0.62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoId);
export default __webpack_public_path__ + "static/media/logoID.c651a2911b90afad924abff94b8b5db2.svg";
export { ForwardRef as ReactComponent };